// Client layer (TS-2.5.03) - presentational only. Renders a DeckPreview's slide-inventory
// summary, data-as-of stamp and any publish blockers/quality findings, exactly as the server
// computed them (decisions.md D-003 - nothing here recomputes layout).
import type { DeckPreview } from "../../api/generated/contracts";
import { formatDateTime } from "./lib/deckFormat";
import { strings } from "../../strings";

export interface DeckPreviewPanelProps {
  readonly preview: DeckPreview;
}

const S = strings.decks.preview;

export function DeckPreviewPanel({ preview }: DeckPreviewPanelProps) {
  return (
    <section className="eg-deck-preview" aria-labelledby="eg-deck-preview-heading">
      <h2 id="eg-deck-preview-heading">{S.heading}</h2>
      <p>
        {S.dataAsOf}: {formatDateTime(preview.header.dataAsOfUtc)}
      </p>
      <p>
        {S.slideCount}: {preview.inventory.totalSlideCount}
      </p>

      <h3>{S.sections}</h3>
      <ul>
        {preview.inventory.sections.map((section) => (
          <li key={section.slideKind}>
            {section.slideKind}: {section.slideCount}
          </li>
        ))}
      </ul>

      {preview.publishBlockers.length > 0 && (
        <div role="alert" className="eg-deck-preview__blockers">
          <p>{S.blockers}</p>
          <p>{S.blockersHint}</p>
          <ul>
            {preview.publishBlockers.map((blocker, index) => (
              <li key={`${blocker.code}-${index}`}>{blocker.message}</li>
            ))}
          </ul>
        </div>
      )}

      {preview.quality.warnings.length > 0 && (
        <div className="eg-deck-preview__quality">
          <p>{S.quality}</p>
          <ul>
            {preview.quality.warnings.map((warning, index) => (
              <li key={`${warning.code}-${warning.entityKey ?? index}`}>
                [{warning.severity}] {warning.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
